import jwtDecode from 'jwt-decode';
/**
 * Decodifica il JWT del config customer
 * @param jwt - Il token JWT da decodificare
 * @returns Il config decodificato o null se fallisce
 */
export var decodeCustomerConfig = function (jwt) {
    try {
        var decoded = jwtDecode(jwt);
        return decoded;
    }
    catch (error) {
        console.warn('Failed to decode customer config JWT:', error);
        return null;
    }
};
/**
 * Confronta due versioni nel formato semver
 * @param current - Versione corrente (es. "1.14.5")
 * @param required - Versione minima richiesta (es. "1.14.5")
 * @returns true se current >= required
 */
export var compareVersions = function (current, required) {
    try {
        var currentParts = current.split('.').map(Number);
        var requiredParts = required.split('.').map(Number);
        // Assicuriamoci che entrambe le versioni abbiano almeno 3 parti
        while (currentParts.length < 3)
            currentParts.push(0);
        while (requiredParts.length < 3)
            requiredParts.push(0);
        for (var i = 0; i < 3; i++) {
            if (currentParts[i] > requiredParts[i])
                return true;
            if (currentParts[i] < requiredParts[i])
                return false;
        }
        return true; // Sono uguali
    }
    catch (error) {
        console.warn('Failed to compare versions:', error);
        return false;
    }
};
/**
 * Restituisce la versione più bassa tra due versioni
 * @param version1 - Prima versione
 * @param version2 - Seconda versione
 * @returns La versione più bassa (più permissiva)
 */
var getLowerVersion = function (version1, version2) {
    // Se version1 >= version2, version2 è più bassa
    // Altrimenti version1 è più bassa
    return compareVersions(version1, version2) ? version2 : version1;
};
/**
 * Verifica se una feature è abilitata basandosi sul config
 * @param config - Il config decodificato
 * @param featureName - Nome della feature (es. "cortilia")
 * @param platform - Piattaforma corrente ("android" | "ios")
 * @param currentVersion - Versione corrente dell'app
 * @param country - Codice paese corrente
 * @returns true se la feature è abilitata
 */
export var isFeatureEnabled = function (config, featureName, platform, currentVersion, country) {
    // Se il config non è presente, disabilita la feature
    if (!config) {
        return false;
    }
    // WEB
    if (platform === 'web') {
        var webConfig = config.webapp;
        if (!webConfig) {
            return false;
        }
        // N.B. Per il web, la feature è semplicemente true/false
        // Quando Mike restituirà il versioning come su mobile, aggiorneremo questa logica
        var isEnabled = webConfig[featureName];
        return isEnabled === true;
    }
    // MOBILE
    // Verifica che la feature esista nel config mobile
    var mobileConfig = config.mobile;
    if (!mobileConfig) {
        return false;
    }
    // Verifica la feature specifica
    var featureConfig = mobileConfig[featureName];
    if (!featureConfig) {
        return false;
    }
    // Per cortilia, verifica versione e paese
    if (featureName === 'cortilia' &&
        'android' in featureConfig &&
        'ios' in featureConfig &&
        'country' in featureConfig) {
        var cortiliaConfig = featureConfig;
        // Verifica la versione per la piattaforma corrente
        var requiredVersion = platform === 'android' ? cortiliaConfig.android : cortiliaConfig.ios;
        if (!compareVersions(currentVersion, requiredVersion)) {
            return false;
        }
        // Verifica che il paese sia supportato
        if (!country || !cortiliaConfig.country.includes(country)) {
            return false;
        }
    }
    // Per fastMeal, lunchbox, budgetFriendly, noCook, gamification, cortiliaAuguriPlanter, mealPrep, planPreferences e airFryer, verifica solo versione
    if ((featureName === 'fastMeal' ||
        featureName === 'lunchbox' ||
        featureName === 'budgetFriendly' ||
        featureName === 'noCook' ||
        featureName === 'gamification' ||
        featureName === 'cortiliaAuguriPlanter' ||
        featureName === 'mealPrep' ||
        featureName === 'planPreferences' ||
        featureName === 'airFryer') &&
        'android' in featureConfig &&
        'ios' in featureConfig) {
        var versionedConfig = featureConfig;
        // Per gamification, usa la versione più bassa tra le due piattaforme
        // per garantire comportamento uniforme su iOS e Android a parità di versione app
        if (featureName === 'gamification') {
            var lowerVersion = getLowerVersion(versionedConfig.android, versionedConfig.ios);
            if (!compareVersions(currentVersion, lowerVersion)) {
                return false;
            }
        }
        else {
            // Per le altre feature, mantieni il comportamento originale
            var requiredVersion = platform === 'android' ? versionedConfig.android : versionedConfig.ios;
            if (!compareVersions(currentVersion, requiredVersion)) {
                return false;
            }
        }
    }
    return true;
};
